import { render, staticRenderFns } from "./TableBalanceRecurringSMS.vue?vue&type=template&id=32abe04a&"
import script from "./TableBalanceRecurringSMS.vue?vue&type=script&lang=js&"
export * from "./TableBalanceRecurringSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports